import { Route, Routes } from "react-router-dom";
import React from "react";
import AuthLayout from "./AuthLayout";
import { LoginPage } from "./LoginPage";

const AuthWrapper = () => (
    <Routes>
        <Route element={<AuthLayout />}>
            <Route path="login" element={<LoginPage />} />
            <Route index element={<LoginPage />} />
        </Route>
    </Routes>
);

export default AuthWrapper;
